import { render } from "./bc-import-data.vue?vue&type=template&id=41d31082&scoped=true"
import script from "./bc-import-data.vue?vue&type=script&lang=js"
export * from "./bc-import-data.vue?vue&type=script&lang=js"

import "./bc-import-data.vue?vue&type=style&index=0&id=41d31082&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d31082"]])

export default __exports__